import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import VguardIcon from "../../assets/icons/VguardIcon.svg";
import "./topBar.css";
import Hamburger from "../../assets/hamburger.svg";
import { useNavigate, useLocation } from "react-router-dom";
import DomainConfig from "../../constants/DomainConfig.json";
import RouteConstants from "../../constants/RouteConstants.json";

const TopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [domain, setDomain] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const path = location.pathname;

    if (path === "/faq") {
      setActiveTab("faq");
    } else if (path === "/products") {
      setActiveTab("products");
    } else {
      setActiveTab("home");
    }
  }, [location.pathname]);

  const getActiveTabStyle = (tabName) => {
    return activeTab === tabName
      ? {
          color: "white",
          textDecoration: "underline",
          textUnderlineOffset: "10px",
        }
      : {};
  };

  useEffect(() => {
    const host = window.location.hostname;
    const hostname = host.split(".").pop();
    setDomain(hostname);
  }, [location.hostname]);

  const handleSelect = (selectedTab) => {
    setActiveTab(selectedTab);
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div>
      <Navbar className="topNavBar" fixed="top" data-bs-theme="dark">
        <Container fluid>
          <div
            className={scrolled ? "topBar-elements-scroll" : "topBar-elements"}
          >
            {/* Logo */}
            <Navbar.Brand>
              <img
                src={VguardIcon}
                alt="Logo"
                className="VguardIcon"
                onClick={() => {
                  handleSelect("home");
                  navigate(RouteConstants.HOME);
                }}
              />
            </Navbar.Brand>

            {/* Hamburger Icon for Mobile */}
            <div className="hamburger-icon" onClick={toggleMobileMenu}>
              <img src={Hamburger} alt="Menu" />
            </div>

            {/* Navigation Links */}
            <div className={`nav-groups ${isMobileMenuOpen ? "nav-open" : ""}`}>
              <div className="nav-group-1">
                <Nav.Item>
                  <Nav.Link
                    onClick={() => handleSelect("home")}
                    className={activeTab === "home" ? "active-tab" : ""}
                    href={`/#/`}
                  >
                    Home
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    href={`/#/faq`}
                    onClick={() => handleSelect("faq")}
                    className={activeTab === "faq" ? "active-tab" : ""}
                  >
                    FAQ
                  </Nav.Link>
                </Nav.Item>
              </div>
              <div className="nav-group-2">
                <Nav.Item>
                  <Nav.Link
                    href={domain == "in" ? `https://www.vguard.in/home/customer-care` : `https://vguard.com/`}
                    target="_blank"
                    
                    className={activeTab === "customerCare" ? "active-tab" : ""}
                  >
                    Customer Care
                  </Nav.Link>
                </Nav.Item>
              </div>
            </div>

            {/* Overlay for Mobile Menu */}
            {isMobileMenuOpen && (
              <div className="overlay" onClick={toggleMobileMenu}></div>
            )}
          </div>
        </Container>
      </Navbar>
    </div>
  );
};

export default TopBar;
